// globals

$(function(){
  $(window).on('load scroll', function() {
      if($('.js-contact-toggle').length){
          add_class_in_scrolling($('.js-contact-toggle'),$('.js-contact'));
      }
  });
  
  // スクロールで要素が表示された時にclassを付与する
  function add_class_in_scrolling(toggle,target) {
      var winScroll = $(window).scrollTop();
      var winHeight = $(window).height();
      var scrollPos = winScroll + winHeight;
      
      toggle.each(function(){
        if($(this).offset().top < scrollPos) {
          target.addClass('is-active');
        }else{
          target.removeClass('is-active');
        }
      })
  }
});